<script lang="ts" setup>
import { getNavItemByID } from '@/ts/management/view-navigation-management.ts';
import type { CategoryID } from '@/ts/types/category-id-types.ts';
import NavLink from '../../nav-link.vue';
import { computed } from 'vue';
import { isModal } from '@/ts/management/modal-management.ts';
import type { ClientConfigNavItem } from '@/ts/types/client-config-types.ts';
import type { LangTextLocation } from '@/ts/types/lang-label-types.ts';
const props = defineProps<{view: CategoryID, icon: string, explText?: string, lowercase?: boolean, label?: string, location?: LangTextLocation}>();
const navLinkBind = computed<ClientConfigNavItem>(() => {
    if(isModal(props.view)){
        return { label: props.label, id: props.view };
    }

    const res = getNavItemByID(props.view);
    if(props.label) res.label = props.label;

    return res;
});
const includeBtn = computed<boolean>(() => {
    return navLinkBind.value.id != 'error';
});
</script>

<template>
    <div class="menu-item" v-if="includeBtn">
        <div class="icon" v-html="icon"></div>
        <nav-link v-bind="{ ...navLinkBind, ...{ location }}" :class="{'menu-item': explText || lowercase, lowercase}">
            <template v-if="explText">
                <div class="expl-text">{{ explText }}</div>
            </template>
        </nav-link>
    </div>
</template>

<style lang="scss" scoped>
    @use './mobile-nav-side-item.scss';
</style>